/**
 * pyrographyPatterns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const pyrographyPatternsPack: ToilePack = {
    slug: 'pyrography-patterns',
    category: 'pyrography',
    name: 'Pyrography patterns',
    tagline: tagline('designs', 'scenes', 'treatments'),
    chips: chips('scenes', 'treatments'),
    ratio: SQUARE,
    readings: [
        {key: 'mountain', label: 'Mountain scene', subject: 'a mountain range behind a pine treeline, a lake in front'},
        {key: 'wolf', label: 'Wolf', subject: 'a wolf head in three-quarter view, ruff fur detailed'},
        {key: 'wreath', label: 'Floral wreath', subject: 'roses, eucalyptus and small berries in a ring'},
    ],
    styles: [
        {key: 'template', label: 'Transfer template', style: 'printable transfer template, contour lines only', palette: 'black line on pure white', framing: 'flat, centered, no wood'},
        {key: 'burned', label: 'Woodburned', style: 'finished woodburn, hatched and stippled shading', palette: 'warm scorch tones on pale birch', framing: 'flat panel, straight on'},
        {key: 'rustic', label: 'Rustic round', style: 'live-edge round with the bark left on', palette: 'warm burn on raw wood', framing: 'hung on a plank wall, raking light'},
    ],
    directions: ['a lighthouse instead', 'with a name burned in', 'fewer lines, bolder'],
}
